import OperationParameterTableConfig from "../OperationParametrTableConfig";

const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "group",
            label: t ? t("common.group") : "Grupa",
            column: 1,
            type: "dictionary",
            searchBy: function (option) {
                return option.name
            },
            useSelect: true,

            dictionary: "operatingParameterTemplate/group",
            mandatory: false,
            renderOption: (option) => option.name,
            placeholder: t ? t("parameters.search_group") : "Wyszukaj grupę"
        },
        {
            conditionalOn: "group",
            conditionalOnNotNull: true,
            name: "operatingParameterTemplates",
            label: t ? t("object_types.operating_parameter_template") : "Parametry pracy",
            type: "table",
            tableConfig: {
                data: function (formData) {
                    return formData.group?.operatingParameterTemplates;
                },
                columns: OperationParameterTableConfig(t),
                checked: true
            },
        },

    ]
});

export default fields;
